import { useSelector } from 'react-redux';
import { selectPermissions, selectIsSuperAdmin } from '../../app/store/slices/authSlice';
import { hasPermission, canAccessModule } from '../utils/rbac';

/**
 * Returns whether the current user can perform an action on a module.
 *
 * Usage:
 *   const canCreate = usePermission('vaccines', 'create');
 *   const canRead   = usePermission('users', 'read');
 */
export function usePermission(module, action) {
  const permissions = useSelector(selectPermissions);
  const isSuperAdmin = useSelector(selectIsSuperAdmin);
  console.log(`Checking permission for module: ${module}, action: ${action}, isSuperAdmin: ${isSuperAdmin}`);
  return hasPermission(isSuperAdmin, permissions, module, action);
}

/**
 * Returns whether user has at least read access to a module (for sidebar visibility).
 */
export function useModuleAccess(module) {
  const permissions = useSelector(selectPermissions);
  const isSuperAdmin = useSelector(selectIsSuperAdmin);
  return canAccessModule(isSuperAdmin, permissions, module);
}

/**
 * Returns full permissions map + isSuperAdmin flag.
 */
export function useRbac() {
  const permissions = useSelector(selectPermissions);
  const isSuperAdmin = useSelector(selectIsSuperAdmin);
  return { permissions, isSuperAdmin };
}
